"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_ffc3a631{position:relative;padding:5px 38px}.root_ffc3a631 .ms-Link{font-size:12px}\n" }]);
exports.root = "root_ffc3a631";
//# sourceMappingURL=GroupFooter.scss.js.map